'use client';

import { Toaster } from 'sonner';

import { Iconify } from '../iconify';

export function Snackbar() {
  return (
    <Toaster
      expand
      closeButton
      gap={12}
      offset={16}
      visibleToasts={4}
      position="top-right"
      className="w-[300px]"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: 'flex items-center gap-3 min-h-[52px] rounded-xl w-full bg-white shadow-lg p-2',
          icon: 'flex-shrink-0 flex items-center justify-center self-start w-12 h-12 rounded-xl bg-opacity-8',
          loader:
            'relative flex items-center justify-center w-full h-full rounded-inherit overflow-hidden',
          loading: 'inline-flex',
          content: 'flex flex-col gap-0.5 flex-1',
          title: 'text-sm font-medium leading-[20px]',
          description: 'text-sm leading-[18px] opacity-64',
          closeButton:
            'absolute top-0 right-0 w-5 h-5 p-0 rounded-full translate-x-[-6px] translate-y-[6px] hover:bg-gray-100 transition-colors',
          actionButton:
            'inline-flex items-center justify-center rounded-md px-2 py-0.5 text-sm font-semibold border border-current border-opacity-16 hover:bg-opacity-8 hover:border-opacity-24 transition-colors',
          info: 'text-blue-600',
          error: 'text-red-600',
          success: 'text-green-600',
          warning: 'text-yellow-600',
        },
      }}
      icons={{
        loading: <div className="w-6 h-6 rounded-full animate-spin bg-current opacity-64" />,
        info: <Iconify className="w-6 h-6" icon="solar:info-circle-bold" />,
        success: <Iconify className="w-6 h-6" icon="solar:check-circle-bold" />,
        warning: <Iconify className="w-6 h-6" icon="solar:danger-triangle-bold" />,
        error: <Iconify className="w-6 h-6" icon="solar:danger-bold" />,
      }}
    />
  );
}
